import React from "react";
import { V19Page } from "./V19Page";
export default function Recommendations() {
  return <V19Page view="reco" testid="recommendations-view" />;
}
